import { useContext } from "react";
import { ActivitiesContext } from "../../context/activities-context";
import SportTypeFilter from "./SportTypeFilter";

const AgeFilter = () => {
	const {
		ageButtonId,
		setAgeButtonId,
		ageButtonActive,
		setAgeButtonActive,
		setAgeString,
		dictionaryWords,
		isLoadingDictionary,
	} = useContext(ActivitiesContext);

	const ageFilterHandler = (event) => {
		if (ageButtonId === "") {
			setAgeString(event.target.value);
			setAgeButtonId(event.target.id);
			setAgeButtonActive(true);
		} else if (ageButtonId !== event.target.id) {
			setAgeString(event.target.value);
			setAgeButtonId(event.target.id);
			setAgeButtonActive(true);
		} else if (ageButtonId === event.target.id) {
			setAgeString("");
			setAgeButtonId("all");
			setAgeButtonActive(false);
		}
	};

	return (
		<div className="filter-section">
			<h3>{dictionaryWords.forWhom}</h3>
			<div>
				<button
					id="3-5"
					value="AND typicalAgeRange:[* TO 5]"
					onClick={ageFilterHandler}
					className={
						ageButtonActive && ageButtonId === "3-5" ? "active" : ""
					}
				>
					{dictionaryWords.threeFive}
					<i className="fa fa-close"></i>
				</button>
			</div>
			<div>
				<button
					id="6-8"
					value="AND typicalAgeRange:[6 TO 8]"
					onClick={ageFilterHandler}
					className={
						ageButtonActive && ageButtonId === "6-8" ? "active" : ""
					}
				>
					{dictionaryWords.sixEight}
					<i className="fa fa-close"></i>
				</button>
			</div>
			<div>
				<button
					id="9-11"
					value="AND typicalAgeRange:[9 TO 11]"
					onClick={ageFilterHandler}
					className={
						ageButtonActive && ageButtonId === "9-11"
							? "active"
							: ""
					}
				>
					{dictionaryWords.nineEleven}
					<i className="fa fa-close"></i>
				</button>
			</div>
			<div>
				<button
					id="12-15"
					value="AND typicalAgeRange:[12 TO 15]"
					onClick={ageFilterHandler}
					className={
						ageButtonActive && ageButtonId === "12-15"
							? "active"
							: ""
					}
				>
					{dictionaryWords.twelveFifteen}
					<i className="fa fa-close"></i>
				</button>
			</div>
			<div>
				<button
					id="16-17"
					value="AND typicalAgeRange:[16 TO 17]"
					onClick={ageFilterHandler}
					className={
						ageButtonActive && ageButtonId === "16-17"
							? "active"
							: ""
					}
				>
					{dictionaryWords.sixteenSeventeen}
					<i className="fa fa-close"></i>
				</button>
			</div>
			<div>
				<button
					id="18+"
					value="AND typicalAgeRange:[18 TO 54]"
					onClick={ageFilterHandler}
					className={
						ageButtonActive && ageButtonId === "18+" ? "active" : ""
					}
				>
					{dictionaryWords.eighteenPlus}
					<i className="fa fa-close"></i>
				</button>
			</div>
			<div>
				<button
					id="55+"
					value="AND typicalAgeRange:[55 TO *]"
					onClick={ageFilterHandler}
					className={
						ageButtonActive && ageButtonId === "55+" ? "active" : ""
					}
				>
					{dictionaryWords.fiftyFivePlus}
					<i className="fa fa-close"></i>
				</button>
			</div>
			{!isLoadingDictionary && <SportTypeFilter />}
		</div>
	);
};

export default AgeFilter;
